import axios from 'axios';
import {ConstantsContainer} from "../helper/constants";

export const fetchCsrfToken = () => {

    const fetchCsrfTokenUrl = `${ConstantsContainer.hellopayBaseUrl}${ConstantsContainer.csrfTokenEndpoint}`

    return axios.get(fetchCsrfTokenUrl)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        })
}